window.Products.WallArt.Canvas = function() {}
window.Products.WallArt.Canvas.inherits(window.Products.WallArt.WallArt);